import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "../../../axios";
import BankAccountForm from "./BankAccountForm";

export default function BankAccountEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState({
    bank_name: "",
    account_name: "",
    account_number: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/admin/bank-accounts/${id}`)
      .then((res) => setForm(res.data))
      .catch(() => setError("Gagal mengambil data rekening"));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await axios.put(`/admin/bank-accounts/${id}`, form);
      navigate("/admin/bank-accounts");
    } catch (err) {
      setError("Gagal menyimpan perubahan.");
    }
  };

  return (
    <div className="card mt-4">
      <div className="card-header border-bottom">
        <h4 className="mb-0">Edit Rekening Bank</h4>
      </div>
      <div className="card-body">
        {error && <div className="alert alert-danger">{error}</div>}
        <BankAccountForm form={form} setForm={setForm} onSubmit={handleSubmit} />
        <Link to="/admin/bank-accounts" className="btn btn-secondary mt-3">Kembali</Link>
      </div>
    </div>
  );
}
